export default "__VITE_PUBLIC_ASSET__8f332d12__"